import client from "./client";

const PartnerService = {};

PartnerService.get = function () {
  return client.get(`/partner`);
};

PartnerService.getIncomeSplit = function (type = "this-month") {
  return client.get(`/partner/income-split/${type}`);
};

PartnerService.getLedger = function (partnerId, type = "this-month") {
  return client.get(`/partner/${partnerId}/ledger/${type}`);
};

PartnerService.getById = function (partnerId) {
  return client.get(`/partner/${partnerId}`);
};

PartnerService.create = function (data) {
  return client.post(`/partner`, data);
};

PartnerService.update = function (partnerId, data) {
  return client.put(`/partner/${partnerId}`, data);
};

PartnerService.delete = function (partnerId) {
  return client.del(`/partner/${partnerId}`);
};

export default PartnerService;
